<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' ,fullScreenBackdrop:true}"></ngx-loading>
<main class="main-site-wrap wrapper">
    <app-header></app-header>
    <div class="site-content-wrap position-relative">
        <app-sidebar></app-sidebar>
        <!--start page wrapper -->
        <div class="page-wrapper">



            <div class="page-content cropper-wrap">
                <div class="row">
                    <div class="col-md-6">
                        <div class="cropper-upload-btn">
                            <input type="file" (change)="fileChangeEvent($event)" accept="image/*" />
                            <button (click)="uploadImage()"> upload Image</button>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="cropper-box">
                                    <image-cropper [imageChangedEvent]="imageChangedEvent" [imageURL]="imageURL" [maintainAspectRatio]="true" [containWithinAspectRatio]="containWithinAspectRatio" [aspectRatio]="aspectRatio" [cropperMinWidth]="128" [onlyScaleDown]="true" [roundCropper]="false"
                                        [canvasRotation]="canvasRotation" [(transform)]="transform" [alignImage]="'center'" [style.display]="showCropper ? null : 'none'" [allowMoveImage]="allowMoveImage" [hidden]="hidden" imageAltText="Alternative image text"
                                         output="blob" format="png" (imageCropped)="imageCropped($event);imageCropped1($event)" (imageLoaded)="imageLoaded()" (cropperReady)="cropperReady($event)" (loadImageFailed)="loadImageFailed()"></image-cropper>
                                    <div *ngIf="loading" class="loader">Loading...</div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="cropper-priview-img">
                                    <img [src]="croppedImage" [style.border]="croppedImage ? '1px solid black' : 'none'" class="w-100" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="upload-container">
                        <input type="file" (change)="onFileSelected($event)" />
                        <button (click)="uploadFile()" [disabled]="!selectedFile">Upload</button>
                      
                        <div *ngIf="progress > 0">
                          <progress [value]="progress" max="100"></progress>
                          <span>{{ progress }}%</span>
                        </div>
                      
                        <div *ngIf="message">{{ message }}</div>
                      </div>

                </div>




            </div>

        </div>

    </div>
    <app-footer></app-footer>

</main>